<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<div class="row">
    <div class="col-md-2">
        <mat-form-field>
            <mat-select placeholder="Company" disabled [(ngModel)]="customerKey">
                <mat-option [value]="customerKey">{{companyName}} </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-3">
        <ng-multiselect-dropdown id="regionDropDown" placeholder="Regions" [(ngModel)]="subCustomerId"
            (onDeSelect)="displayRegionDetails()" matNativeControl [disabled]="disableRegion" [data]="regionData"
            [settings]="regionDropdownSettings" (onSelect)="displayRegionDetails()"
            (onSelectAll)="onSelectAllRegions($event)" (onDeSelectAll)="onSelectAllRegions($event)">

        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-3">
        <ng-multiselect-dropdown id="divisionDropDown" placeholder="Divisions" [(ngModel)]="divisionId"
            (onDeSelect)="displayDivisionDetails()" matNativeControl [disabled]="disableDivision"
            [data]="divisionData" [settings]="divisionDropdownSettings" (onSelect)="displayDivisionDetails()"
            (onSelectAll)="onSelectAllDivisios($event)" (onDeSelectAll)="onSelectAllDivisios($event)">
        </ng-multiselect-dropdown>
    </div>
    <div class="col-md-4">
        <ng-multiselect-dropdown id="locationDropDown" placeholder="Locations" [(ngModel)]="locationId"
            (onDeSelect)="displayLocationDetails()" matNativeControl [disabled]="disableLocation"
            [data]="locationData" [settings]="locationDropdownSettings" (onSelect)="displayLocationDetails()"
            (onSelectAll)="onSelectAllLocations($event)" (onDeSelectAll)="onSelectAllLocations($event)">
        </ng-multiselect-dropdown>
    </div>
</div>